import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";

const createApi = (base) => ({
  getPagedList: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetPagedList?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getDetail: async (id) => {
    const response = await api.request({
      url: `${base}/GetDetail?${queryString.stringify({ id })}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  registerOfficeReceipt: async (data) => {
    const response = await api.request({
      url: `${base}/RegisterOfficeReceipt`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  markReadyForBank: async (data) => {
    const response = await api.request({
      url: `${base}/MarkReadyForBank`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  dispatchToBank: async (data) => {
    const response = await api.request({
      url: `${base}/DispatchToBank`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  confirmBankReceipt: async (data) => {
    const response = await api.request({
      url: `${base}/ConfirmBankReceipt`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  dispatchToLendtech: async (data) => {
    const response = await api.request({
      url: `${base}/DispatchToLendtech`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  suspend: async (data) => {
    const response = await api.request({
      url: `${base}/Suspend`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  resumeFromSuspend: async (data) => {
    const response = await api.request({
      url: `${base}/ResumeFromSuspend`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },
});

const GuaranteeChequeCustodyApi = createApi(
  "SLN/Management/GuaranteeChequeCustody"
);

export const guaranteeChequeCustodyOperatorApi = createApi(
  "SLN/SolarentOperator/GuaranteeChequeCustody"
);

export default GuaranteeChequeCustodyApi;
